var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_4242)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#0095DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2824 27.5631H12.1202C10.0897 27.5631 8.4375 25.8844 8.4375 23.8207V13.4939C8.4375 11.4305 10.0893 9.75146 12.1202 9.75146H17.2011C17.6311 9.75146 17.9801 10.1061 17.9801 10.5431C17.9801 10.9801 17.6311 11.3347 17.2011 11.3347H12.1202C10.9486 11.3347 9.99547 12.3033 9.99547 13.4939V23.8211C9.99547 25.0117 10.9486 25.9802 12.1202 25.9802H22.2824C23.454 25.9802 24.4067 25.0117 24.4067 23.8211V18.6577C24.4067 18.2207 24.7557 17.866 25.1857 17.866C25.6157 17.866 25.9647 18.2207 25.9647 18.6577V23.8211C25.9647 25.8844 24.3128 27.5631 22.2824 27.5631Z",
    fill: "#9DDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.299 22.8256L24.9401 15.0606L21.0451 11.1024L13.4041 18.8675C13.1867 19.0884 13.0835 19.4078 13.1174 19.7545L13.4165 22.813L16.4261 23.1169C16.7677 23.1514 17.0817 23.0465 17.299 22.8256ZM27.0994 12.8662C27.7168 12.2388 27.7168 11.2216 27.0994 10.5942L25.4402 8.90802C24.8228 8.28066 23.8218 8.28066 23.2045 8.90802L21.77 10.3658L25.6649 14.3239L27.0994 12.8662Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_4242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.cf60cdc7ce8853cbcdf3c68336f9d2d4.svg";
export { ForwardRef as ReactComponent };